module.exports = __webpack_public_path__ + "static/breachIcon-a73a133ce07b079c289937272add9f29.png";